import React from "react";
import Image from "@/components/Image/image";
import Link from "@/components/Link";
import styles from "./blog.module.scss";
import { ImageStoryblok, AssetStoryblok } from "@/types/component-types-sb";

interface Props {
  image?: AssetStoryblok;
  children: React.ReactNode;
  aspectMobile?: ImageStoryblok["aspect_ratio_mobile"];
  aspectDesktop?: ImageStoryblok["aspect_ratio_desktop"];
  link?: string;
}

const BlogIndexFeaturedItem = (props: Props) => {
  const {
    image,
    children,
    aspectMobile = "3/2",
    aspectDesktop = "4/3",
    link = "",
  } = props;
  return (
    <>
      {image && (
        <Link href={link} className={styles.featuredItemImage}>
          <Image
            alt={image.alt}
            aspectMobile={aspectMobile}
            aspectDesktop={aspectDesktop as any}
            filename={image.filename}
            focus={image.focus}
            priority
          />
        </Link>
      )}
      <div className={styles.featuredItemCopy}>{children}</div>
    </>
  );
};

export default BlogIndexFeaturedItem;
